module.exports = __webpack_public_path__ + "static/media/Gallery16.c25786f2.jpg";